module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.reverseItems
    }
  }, [_vm._v("\n        " + _vm._s(_vm.getTranslation('lbl_customer_name')) + "\n        "), _c('span', {
    staticClass: "arrow",
    class: _vm.sortOrder > 0 ? 'asc' : 'dsc'
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.reverseItems
    }
  }, [_vm._v("\n        " + _vm._s(_vm.getTranslation('lbl_customer_code')) + "\n        "), _c('span', {
    staticClass: "arrow",
    class: _vm.sortOrder > 0 ? 'asc' : 'dsc'
  })]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_customer_active')))]), _vm._v(" "), (_vm.actionCol) ? _c('th', {
    staticClass: "action"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_grid_col_action')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredData), function(customer, index) {
    return _c('tr', {
      key: customer._id
    }, [_c('td', [(_vm.isEdit && _vm.editIndex === index) ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (customer.name),
        expression: "customer.name"
      }],
      attrs: {
        "type": "text",
        "minlength": "1"
      },
      domProps: {
        "value": (customer.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          customer.name = $event.target.value
        }
      }
    })] : [_c('span', [_vm._v(_vm._s(customer.name))])]], 2), _vm._v(" "), _c('td', [(_vm.isEdit && _vm.editIndex === index) ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (customer.code),
        expression: "customer.code"
      }],
      attrs: {
        "minlength": "1",
        "maxlength": "4",
        "type": "text"
      },
      domProps: {
        "value": (customer.code)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          customer.code = $event.target.value
        }
      }
    })] : [_c('span', [_vm._v("****")])]], 2), _vm._v(" "), _c('td', {
      staticClass: "middle-alignment"
    }, [_c('app-switch', {
      attrs: {
        "autoSave": !_vm.isEdit,
        "disabled": _vm.isEdit && _vm.editIndex !== index,
        "isInList": true,
        "item": customer,
        "identification": customer.name + 'active'
      },
      model: {
        value: (customer.active),
        callback: function($$v) {
          customer.active = $$v
        },
        expression: "customer.active"
      }
    })], 1), _vm._v(" "), (_vm.actionCol) ? _c('td', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [(_vm.editBtn && _vm.editIndex !== index) ? [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "disabled": _vm.isEdit,
        "title": _vm.getTranslation('lbl_edit')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.edit(customer, index)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : (_vm.isEdit && _vm.editIndex === index) ? [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "title": _vm.getTranslation('lbl_check')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.update(customer)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-floppy-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      attrs: {
        "title": _vm.getTranslation('lbl_cancel')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.cancel(customer, index)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-ban"
    })])] : _vm._e(), _vm._v(" "), (_vm.deleteBtn && _vm.editIndex !== index) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "disabled": _vm.editIndex && _vm.editIndex !== index
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(customer)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-trash",
      attrs: {
        "title": _vm.getTranslation('lbl_delete'),
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 2) : _vm._e()])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4826c84f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/customer/CustomerTable.vue
// module id = 677
// module chunks = 0